import { actionGenerator } from '../../utils/redux/actionGenerator';
import { ELegalCheckActions } from '../../constants/actionTypes/legalCheck';
import { TAgreementTemplate } from '../../packages/Agreement/types';
import { EStepCode } from '../../types/requestFormSchema';

export const setLegalCheckId = actionGenerator<ELegalCheckActions.SET_LEGAL_ID, number>(
  ELegalCheckActions.SET_LEGAL_ID,
);

export const setIsRegistered = actionGenerator<ELegalCheckActions.SET_IS_REGISTERED, boolean>(
  ELegalCheckActions.SET_IS_REGISTERED,
);

export const setLegalCheckPrice = actionGenerator<ELegalCheckActions.SET_PRICE, string>(ELegalCheckActions.SET_PRICE);

export const setAgreementOffer = actionGenerator<ELegalCheckActions.SET_AGREEMENT_OFFER, TAgreementTemplate[]>(
  ELegalCheckActions.SET_AGREEMENT_OFFER,
);

export const setAgreementPersonal = actionGenerator<ELegalCheckActions.SET_AGREEMENT_PERSONAL, TAgreementTemplate[]>(
  ELegalCheckActions.SET_AGREEMENT_PERSONAL,
);

export const setCurrentStep = actionGenerator<ELegalCheckActions.SET_CURRENT_STEP, EStepCode>(
  ELegalCheckActions.SET_CURRENT_STEP,
);

export type TSetLegalCheckId = ReturnType<typeof setLegalCheckId>;
export type TSetIsRegistered = ReturnType<typeof setIsRegistered>;
export type TSetLegalCheckPrice = ReturnType<typeof setLegalCheckPrice>;
export type TSetAgreementOffer = ReturnType<typeof setAgreementOffer>;
export type TSetAgreementPersonal = ReturnType<typeof setAgreementPersonal>;
export type TSetCurrentStep = ReturnType<typeof setCurrentStep>;

export type TLegalCheckActions =
  | TSetLegalCheckId
  | TSetLegalCheckPrice
  | TSetAgreementOffer
  | TSetAgreementPersonal
  | TSetIsRegistered
  | TSetCurrentStep;
